// Verified through public school listings. Add Instagram or X only after the school confirms the exact profile URL.
export const schoolSocialLinks = {
  facebook: 'https://www.facebook.com/770040893010546/',
} as const;
